import React from 'react'
import { Container, FormInfoWrapper } from './style'
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';

const FirstMenstruationCycle = () => {
  const { selectedClient } = useSelector((state: RootState) => state.professionals);

  return (
    <Container>
      <FormInfoWrapper>
        <p>At which age did you have your first monthly menstruation cycle?</p>
        <em>{selectedClient?.bio?.clientBioFemale?.firstMensAge}</em>
      </FormInfoWrapper>
    </Container>
  )
}

export default FirstMenstruationCycle
